import { render, staticRenderFns } from "./addFolderDialog.vue?vue&type=template&id=5c2ae35b"
import script from "./addFolderDialog.vue?vue&type=script&lang=js"
export * from "./addFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports